/**
 * Created by Abner Sui on 01/22/2019.
 * Description:
 *
 * ------ maintenance history ------
 */

import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as MarkJS from 'mark.js/dist/mark';

import { BlastEmail } from '../../tamalelibs/models/blastemail.model';
import { Store } from '@ngrx/store';
import { IAppState } from '../../tamalelibs/redux/app.state';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'blastemail-detail-header',
    templateUrl: './blastemail-detail-header.component.html',
    styleUrls: ['./blastemail-detail-header.component.scss']
})
export class BlastEmailDetailHeaderComponent implements OnInit, AfterViewInit {
    @Input() blastEmail: BlastEmail;
    @Input() highlightText: string[];
    @Output() toggle: EventEmitter<any> = new EventEmitter();
    @ViewChild('submitInfo', { static: false }) submitInfoEle: ElementRef;
    @ViewChild('subject', { static: false }) subjectEle: ElementRef;

    public collapsed = false;
    // public popoverConfig: PopoverConfig;

    constructor(public _store: Store<IAppState>,
        private _datepipe: DatePipe,
    ) {
    }

    ngOnInit() {
        // this._initPopover();
        // this._initTouchListener();
    }

    ngAfterViewInit() {
        const submiteInfoMark = new MarkJS(this.submitInfoEle.nativeElement);
        const subjectMark = new MarkJS(this.subjectEle.nativeElement);
        submiteInfoMark.mark(this.highlightText, {
            'element': 'span',
            'className': 'highlight',
            'separateWordSearch': false
        });
        subjectMark.mark(this.highlightText, {
            'element': 'span',
            'className': 'highlight',
            'separateWordSearch': false
        });
    }

    getSubmitInfoTitle() {
        let title = this.blastEmail.type + ' from ';
        if (this.blastEmail.contact) {
            title += this.blastEmail.contact.name;
            title += ' of ' + this.blastEmail.contact.company;
        } else {
            title += this.blastEmail.fromPersonName + '(' + this.blastEmail.fromEmailAddress + ')';
        }
        title += ' on ';
        title += this.getWeekdayByDate(this.blastEmail.time) + ', ';
        title += this._datepipe.transform(this.blastEmail.time.getTime(), 'dd MMM yyyy, HH:mm');
        return title;
    }

    getWeekdayByDate(value: Date): any {
        const weekArray = new Array('Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday');
        const myDate = value;
        const week = weekArray[myDate.getDay()];
        return week;
    }

    // @HostListener('document:click', ['$event'])
    // onclick(e: MouseEvent) {
    //     if (this.popoverConfig) {
    //         this.popoverConfig.showPopover = false;
    //     }
    // }

    onShowAttachmentList(e) {
        // this.popoverConfig.items = [];
        // this.blastEmail.attachments.forEach((item: DocumentEmail, key: string, map: Map<string, DocumentEmail>) => {
        //     this.popoverConfig.items.push(AttachmentView.parseFromDocumentEmail(item));
        // });
        // this.popoverConfig.showPopover = true;
        // if (e && e.stopPropagation) {
        //     e.stopPropagation();
        // } else {
        //     window.event.cancelBubble = true;
        // }
    }

    onToggle() {
        this.collapsed = !this.collapsed;
        this.toggle.emit();
    }

    // onTouch() {
    //     if (this.popoverConfig) {
    //         this.popoverConfig.showPopover = false;
    //     }
    // }

    // private _initPopover() {
    //     this.popoverConfig = new PopoverConfig();
    //     this.popoverConfig.items = [];
    //     this.blastEmail.attachments.forEach((item: DocumentEmail, key: string, map: Map<string, DocumentEmail>) => {
    //         this.popoverConfig.items.push(AttachmentView.parseFromDocumentEmail(item));
    //     });
    //     this.popoverConfig.showPopover = false;
    // }

    // private _initTouchListener() {
    //     window.addEventListener('touchstart', this.onTouch, false);
    // }

}
